var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29275 12.2927L5.29273 12.2927C5.19985 12.3856 5.12617 12.4959 5.0759 12.6172C5.02563 12.7386 4.99976 12.8686 4.99976 13C4.99976 13.1314 5.02563 13.2614 5.0759 13.3828C5.12617 13.5042 5.19985 13.6144 5.29273 13.7073C5.38562 13.8002 5.49589 13.8739 5.61724 13.9241C5.7386 13.9744 5.86867 14.0003 6.00003 14.0003C6.1314 14.0003 6.26147 13.9744 6.38282 13.9241C6.50418 13.8739 6.61445 13.8002 6.70734 13.7073L11.7071 8.7075C11.8001 8.61463 11.8739 8.50434 11.9242 8.38294C11.9745 8.26154 12.0004 8.13141 12.0004 8C12.0004 7.86859 11.9745 7.73846 11.9242 7.61706C11.8739 7.49567 11.8001 7.38538 11.7071 7.2925L6.70734 2.2927C6.51975 2.10511 6.26532 1.99973 6.00003 1.99973C5.73474 1.99973 5.48032 2.10511 5.29273 2.2927C5.10514 2.48029 4.99976 2.73471 4.99976 3C4.99976 3.26529 5.10514 3.51972 5.29273 3.70731L5.29275 3.70733L9.586 8L5.29275 12.2927Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/ArrowDownWhite.44aaebc785db272a9e66796ec5708964.svg";
export { ForwardRef as ReactComponent };